<template>
    <section>
        <StepsHeader :steps="steps"
                     :currentStep="currentStoreStep"
                     :stepsDone="stepsDone"
                     @goToStep="goToStep"/>
        <perfect-scrollbar class="wizards-steps">
            <Step1SelectCurrentGroups v-if="currentStep === 1" />
            <Step2ExternalSystems v-else-if="currentStep === 2" />
            <Step3Administrators v-else-if="currentStep === 3" />
            <Step4Templates v-else-if="currentStep === 4" />
            <Step5Users v-else-if="currentStep === 5" />
            <Step6Summary v-else-if="currentStep === 6" />
        </perfect-scrollbar>
    </section>
</template>
<script charset="utf-8">
    import StepsHeader from "../../Shared/Steps/StepsHeader.vue";
    import Step1SelectCurrentGroups from "./Steps/Step1SelectCurrentGroups.vue";
    import Step2ExternalSystems from "./Steps/Step2ExternalSystems.vue";
    import Step3Administrators from "./Steps/Step3Administrators.vue";
    import Step4Templates from "./Steps/Step4Templates.vue";
    import Step5Users from "./Steps/Step5Users.vue";
    import Step6Summary from "./Steps/Step6Summary.vue";
    import { newCadenceSteps } from "./Data/newCadenceSteps";

    export default {
        name: "NewCadenceWizards",
        components: {
            Step1SelectCurrentGroups,
            StepsHeader,
            Step2ExternalSystems,
            Step3Administrators,
            Step4Templates,
            Step5Users,
            Step6Summary
        },
        data() {
            return {
                steps: newCadenceSteps
            }
        },

        computed: {
            currentStep() {
                return parseInt(this.$route.params.step);
            },
            currentStoreStep() {
                return this.$store.state.wizardNewCadence.step;
            },
            stepsDone() {
                if (this.$store.state.wizardNewCadence.stepsDone === undefined)
                    return [];

                return this.$store.state.wizardNewCadence.stepsDone;
            }
        },
        methods: {
            async goToStep(data) {
                if (data.step === this.currentStoreStep)
                    return;

                await this.$store.commit("setWizardNewCadenceCurrentStep", data.step);
                await this.$router.push({ name: data.routeName, params: { step: data.step } });
            }
        }
    }
</script>
<style lang="scss">
    .wizards-steps {
        max-height: 65vh;
        padding: 0px 20px;
    }
</style>